'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = _react.PropTypes.shape({
  id: _react.PropTypes.number.isRequired,
  title: _react.PropTypes.string.isRequired,
  content: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.string.isRequired,
  contentType: _react.PropTypes.string.isRequired,
  metadataId: _react.PropTypes.string
});


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/featuredContentShape.js
// module id = 355
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15